import { unwrapQuery } from 'src/core/api/unwrapQuery';
import { ErrorBoundary } from 'src/core/common/components/withErrorBoundary';
import { useParams } from 'src/core/common/hooks/useParams';
import { routes } from 'src/core/constants/routes';
import { useBudgetWithDimensionData } from 'src/core/modules/budgets/budgets-by-dimensions/hooks/useBudgetWithDimensionData';

import { useSpendingClick } from '../../../hooks/useSpendingClick';
import { SpendingEntityPanel } from '../../SpendingEntityPanel';
import { BudgetaryExercisesPageSkeleton } from '../../v1/NewBudgetaryExercisesPage/BudgetaryExercisesPageSkeleton';
import { BudgetOverviewPageContentV2 } from '../BudgetOverviewPageContentV2';

/**
 * BudgetOverviewPageV2 - Detail page for a specific Budget V2
 *
 * This component is specifically for the /v2/budgets/:id route and handles
 * displaying budget details using budget definitions and breakdowns.
 */
export const BudgetOverviewPageV2 = () => {
  const { id: budgetId } = useParams(routes.BUDGET_V2_OVERVIEW.path);

  const budgetDataQuery = useBudgetWithDimensionData(budgetId);
  const spendingClick = useSpendingClick();

  // TODO: Handle error state with QueryError Component
  const budgetData = unwrapQuery(budgetDataQuery);
  if (!budgetData) {
    return <BudgetaryExercisesPageSkeleton />;
  }

  return (
    <ErrorBoundary context={{ scope: 'budget-overview-v2', team: 'control' }}>
      <BudgetOverviewPageContentV2
        budgetDefinition={budgetData.budget}
        dimensionData={budgetData.dimensionData}
        spendingClick={spendingClick}
      />
      <SpendingEntityPanel {...spendingClick.entityPanelProps} />
    </ErrorBoundary>
  );
};
